"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrateUserController = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const i18n_1 = require("../../i18n");
const services_1 = require("../../services");
class MigrateUserController {
    constructor() {
        this.inFlight = false;
        this.value = '';
        this.isDirty = false;
        this.isValid = MigrateUserController.validateEmail(this.value);
        this.formError = null;
        this.hasSubmitted = false;
        this.isNewUser = null;
    }
    static validateEmail(str) {
        return typeof str === 'string' && (0, core_shared_1.isEmailAddress)(str);
    }
    submit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.inFlight = true;
            this.formError = null;
            try {
                this.isNewUser = (yield services_1.Services.Rest.rest.SSOUser.selfMigrate({
                    email: this.value
                })).isNewUser;
                this.hasSubmitted = true;
            }
            catch (error) {
                this.formError = (0, i18n_1.Translate)(i18n_1.T.SSO_MIGRATE_FAILED);
            }
            finally {
                this.inFlight = false;
            }
        });
    }
    get hasError() {
        return this.isDirty && !this.isValid;
    }
}
exports.MigrateUserController = MigrateUserController;
tslib_1.__decorate([
    mobx_1.observable
], MigrateUserController.prototype, "inFlight", void 0);
tslib_1.__decorate([
    mobx_1.observable
], MigrateUserController.prototype, "value", void 0);
tslib_1.__decorate([
    mobx_1.observable
], MigrateUserController.prototype, "isDirty", void 0);
tslib_1.__decorate([
    mobx_1.observable
], MigrateUserController.prototype, "isValid", void 0);
tslib_1.__decorate([
    mobx_1.observable
], MigrateUserController.prototype, "formError", void 0);
tslib_1.__decorate([
    mobx_1.observable
], MigrateUserController.prototype, "hasSubmitted", void 0);
tslib_1.__decorate([
    mobx_1.observable
], MigrateUserController.prototype, "isNewUser", void 0);
tslib_1.__decorate([
    mobx_1.action.bound
], MigrateUserController.prototype, "submit", null);
tslib_1.__decorate([
    mobx_1.computed
], MigrateUserController.prototype, "hasError", null);
//# sourceMappingURL=migrate.user.ctrl.js.map